import { extractFieldsFromPattern } from './metadataParser';

/**
 * Get a sample filename from uploaded files for pattern preview
 */
export const getSampleFilename = (uploadedFiles) => {
  return uploadedFiles.length > 0 
    ? uploadedFiles[0].filename 
    : 'project/target/example-file.prep';
};

/**
 * Get pattern extraction preview for current pattern and files
 */
export const getPatternPreview = (uploadedFiles, extractionPattern) => {
  const sampleFilename = getSampleFilename(uploadedFiles);
  return extractFieldsFromPattern(sampleFilename, extractionPattern);
};

/**
 * Process drag-and-drop files
 */
export const processDragDropFiles = (event) => {
  const files = [];
  
  if (event.dataTransfer.items) {
    // Use DataTransferItemList interface
    for (let i = 0; i < event.dataTransfer.items.length; i++) {
      if (event.dataTransfer.items[i].kind === 'file') {
        const file = event.dataTransfer.items[i].getAsFile();
        if (file) files.push(file);
      }
    }
  } else {
    // Use DataTransfer interface
    for (let i = 0; i < event.dataTransfer.files.length; i++) {
      files.push(event.dataTransfer.files[i]);
    }
  }
  
  return files;
};

/**
 * Handle resize drag for bottom panel
 */
export const createResizeHandler = (bottomPanelHeight, setBottomPanelHeight) => {
  return (e) => {
    const startY = e.clientY;
    const startHeight = bottomPanelHeight;
    
    const handleMouseMove = (e) => {
      const deltaY = startY - e.clientY;
      const newHeight = Math.min(Math.max(200, startHeight + deltaY), window.innerHeight - 300);
      setBottomPanelHeight(newHeight);
    };
    
    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
};